<template>
    <v-bottom-navigation :height="height" app grow :background-color="surface ? 'white' : color" :dark="!surface" elevation="6" v-if="isAuthed && phoneOnly" :class="{'navigation-primary-theme': !surface, 'dense': dense}" >
        <template v-for="button in buttons">
            <v-btn v-if="!button.hide" v-haptic :color="color" text v-ripple :key="button.value" :value="button.value" :to="button.to || {name: button.value}" :style="`${bottomSafeArea ? 'padding-bottom: 20px' : ''}`">
                <span v-if="!dense" class="label" :class="{[color + '--text']: $route.name === button.value, 'text--text': $route.name !== button.value}">{{button.text}}</span>
                <v-badge dot :value="!!button.chip && self[button.chip]" :content="self[button.chip]" overlap :color="button.chipColor ? button.chipColor : 'ebadge'" right class="white--text">
                    <v-icon :style="surface || $route.name === button.value ? '' : 'opacity: 0.65'" :color="surface ? ($route.name === button.value ? color : 'text') : 'white'">{{$route.name === button.value || button.filled ? button.icon : `${button.icon}-outline`}}</v-icon>
                </v-badge>
            </v-btn>
        </template>
    </v-bottom-navigation>
</template>

<script>

import GlobalComputed from '@/helpers/global-computed'
import GlobalMethods from '@/helpers/global-methods'

export default {
    data(){
        return {
            self: this,
            value: 'home',
        }
    },
    computed: {
        ...GlobalComputed,
        color(){
            return this.dense ? 'secondary' : 'primary';
        },
        dense(){
            return this.platform === 'web';
        },
        height(){
            return this.dense ? 50 : (this.bottomSafeArea ? 60 + this.bottomSafeArea : 60);
        },
        bottomSafeArea(){
            return this.platform === 'ios' ? 20 : (this.androidNeedsSafeArea ? 36 : 0);
        },
        buttons(){
            let items = [
                {value: 'home', text: 'الرئيسية', icon: 'mdi-home'},
                {value: 'my-courses', text: 'دوراتي', icon: 'mdi-book-multiple'},
                {value: 'courses', text: 'الدورات', icon: 'mdi-play-box-multiple'},
                {value: 'exams', text: 'الامتحانات', icon: 'mdi-clipboard-text', hide:  !this.appData.enable_gen_exm},
                {value: 'wallet', text: ' المحفظة', icon: 'mdi-wallet', hide:  !this.appData.enable_wallet_system},
                {value: 'profile', text: 'حسابي', icon: 'mdi-account-circle'},
                {value: 'help', text: 'الدعم الفني', icon: 'mdi-help-circle', hide:  this.appData.enable_gen_exm},
                // {value: 'settings', text: 'اﻹعدادات', icon: 'mdi-cog'},
            ];
            return items
        },
        surface(){
            // return this.isDark || !this.webPhone;
            return true; // for now, no primaryTheme
        },
    },
    methods: {
        ...GlobalMethods
    },
    mounted(){
        this.value = this.$route.name;
    }
}
</script>

<style lang="scss" scoped>
    .v-bottom-navigation{
        transition: all 0.2s ease-in-out, color 0s, background 0s, border-color 0s;
        &.theme--dark{
            border-top: 1px solid rgba(#fff, 0.1)!important;
        }
        &.dense{
            .v-btn.v-btn--active{
                border-top: 2px solid;
            }
        }
        .v-btn{
            // opacity: 0.75!important;
            &:hover:before{
                opacity: 0!important;
            }
            &.v-btn--active {
                &::before, &:focus::before, &:hover::before{
                    // opacity: 0.07!important;
                    opacity: 0!important;
                }
            }
            // &:active, &:hover, &.v-btn--active{
            //     opacity: 1!important;
            // }
            min-width: 40px!important;
            .label{
                font-size: 9px;
                margin-top: 6px;
            }
            &.v-btn--active{
                // border-bottom: 3px solid!important;
            }
        }

        &.navigation-primary-theme{
            box-shadow: 0px 2px 4px -1px rgb(0 0 0 / 20%), 0px -4px 8px 1px rgb(0 0 0 / 14%), 0px 1px 10px 0px rgb(0 0 0 / 12%)!important;
        }
    }
</style>